import axios from "axios";
import { config } from "../configs/index";

export const baseUrl = `${config.REACT_APP_BASE_URL}/api/admin`;
console.log(config.REACT_APP_BASE_URL, "-config.REACT_APP_BASE_URL");
// export const baseUrl = `https://api.inceptionfinancial.app/api/admin`;

export const http = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "multipart/form-data",
    // "Cache-Control": "no-cache",
    // 'Authorization': `Bearer ${token}`,
  },
});

http.interceptors.request.use(
  function (config) {
    const token = JSON.parse(localStorage.getItem("token"));

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 400) {
      console.log("Error : ", error?.response?.data?.message);
    }
    return Promise.reject(error);
  }
);
